// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const ProductGridBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  .syte-container-wrapper {
    position: relative;
  }
  .syte-discovery {
    position: absolute;
    top: -50px;
    margin-left: 0;
    margin-bottom: -42px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
    .slider-icon-wrapper {
      left: 0;
    }
  }

  .empty-favorite-2 {
    fill: none;
    stroke: ${(props) => props.theme.colors.BLACK};
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .loadImage.error {
    height: 205px;

    @media ${(props) => props.theme.mediaQuery.medium} and ${(props) =>
        props.theme.mediaQuery.mediumMax} and (orientation: landscape) {
      height: 340px;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 267px;
    }

    background: ${(props) => props.theme.colorPalette.gray[500]};
    display: block;
  }
`;

export default css`
  .plp-grid-recos-enabled {
    .color-chips-container + .fulfillment-section {
      margin-top: 51px;
    }

    .color-chips-container + .ranking-wrapper {
      margin-top: 28px;
    }

    .points-and-rewards + .fulfillment-section {
      margin-top: 23px;
    }

    .in-grid-plp-rectangle + .fulfillment-section {
      margin-top: 51px;
    }

    .in-grid-plp-rectangle + .ranking-wrapper {
      margin-top: 28px;
    }

    .loyalty-text-container + .fulfillment-section {
      margin-top: 23px;
    }
  }
`;
